import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// Utility to map class year
const YEAR_LABELS = ["1st Year GNM", "2nd Year GNM", "3rd Year GNM"];
function getYearLabel(course_year) {
  return YEAR_LABELS[(Number(course_year) || 1) - 1] || `Year ${course_year}`;
}

// Utility: number to words
function numberToWords(num) {
  if (!num || isNaN(num)) return "";
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
    'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  function inWords(n) {
    if (n === 0) return "Zero";
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + inWords(n % 100) : "");
    if (n < 100000) return inWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + inWords(n % 1000) : "");
    if (n < 10000000) return inWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + inWords(n % 100000) : "");
    return inWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + inWords(n % 10000000) : "");
  }
  return inWords(num).trim() + " Rupees Only";
}

const Receipt = {
  generatePDF: async (receipt) => {
    // Create a hidden container for rendering the receipt
    const container = document.createElement("div");
    container.style.width = "700px";
    container.style.padding = "24px";
    container.style.background = "#fff";
    container.style.fontFamily = "Arial, sans-serif";
    container.innerHTML = `
      <div style="border:1px solid #eee; border-radius:10px; padding:18px;">
        <div style="display:flex;align-items:center;margin-bottom:10px;">
          <img src="/logo.png" alt="Logo" style="height:38px;margin-right:12px;" />
          <div>
            <h2 style="margin:0;text-align:left;">Sarojini College of Nursing</h2>
            <div style="font-size:15px;">Dhule</div>
            <div style="font-size:12px;">32, Saroday Colony, Nr. New City High School, Dhule - 424001</div>
            <div style="font-size:12px;">Email: sarojinicollegeofnursing@gmail.com | Contact: 02562238754, 8212244</div>
          </div>
        </div>
        <hr/>
        <table style="width:100%;margin-bottom:12px;">
          <tbody>
            <tr>
              <td><b>Receipt No:</b> ${receipt.receipt_id || receipt.id || receipt.fee_id || "-"}</td>
              <td><b>Date:</b> ${receipt.payment_date ? new Date(receipt.payment_date).toLocaleDateString() : "-"}</td>
            </tr>
            <tr>
              <td><b>Name:</b> ${receipt.student_name || "-"}</td>
              <td><b>Class:</b> ${getYearLabel(receipt.course_year)}</td>
            </tr>
            <tr>
              <td><b>Roll No:</b> ${receipt.roll_no || "-"}</td>
              <td><b>Batch:</b> ${receipt.batch_id || "-"}</td>
            </tr>
            <tr>
              <td><b>Account Head:</b> ${receipt.account_head || "-"}</td>
              <td><b>Mode:</b> ${receipt.mode || "-"}</td>
            </tr>
          </tbody>
        </table>
        <table style="width:100%;border-collapse:collapse;">
          <thead>
            <tr>
              <th style="border-bottom:1px solid #888;padding-bottom:4px;">Sr. No.</th>
              <th style="border-bottom:1px solid #888;padding-bottom:4px;">Description</th>
              <th style="border-bottom:1px solid #888;padding-bottom:4px;text-align:right;">Amount (Rs.)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>${receipt.particulars || receipt.account_head || "Fee Payment"}</td>
              <td style="text-align:right;">${Number(receipt.amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            ${receipt.scholarship_amount ? `<tr>
              <td>2</td>
              <td>Scholarship</td>
              <td style="text-align:right;">-${Number(receipt.scholarship_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>` : ""}
            ${receipt.refund ? `<tr>
              <td>3</td>
              <td>Refund</td>
              <td style="text-align:right;">${Number(receipt.refund).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>` : ""}
          </tbody>
        </table>
        <div style="margin:16px 0;font-size:1.15em;font-weight:bold;">
          Amount Paid: ₹${Number(receipt.amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
        </div>
        <div style="margin-top:8px;font-size:1em;">
          <b>In Words:</b> ${receipt.amount ? numberToWords(Number(receipt.amount)) : "-"}
        </div>
        <div style="margin-top:8px;font-size:1em;">
          <b>Transaction Details:</b> ${receipt.reference || "-"}
        </div>
        <div style="margin-top:35px;display:flex;justify-content:space-between;">
          <span>Stamp ____________</span>
          <span>Accountant's Signature ____________</span>
        </div>
        <div style="margin-top:40px;text-align:right;font-size:0.95em;">
          <i>This is a system-generated receipt and does not require physical signature.<br/>Subject to Realization</i>
        </div>
      </div>
    `;
    document.body.appendChild(container);

    const canvas = await html2canvas(container, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pdfWidth = pageWidth * 0.95;
    const imgProps = pdf.getImageProperties(imgData);
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, "PNG", (pageWidth - pdfWidth) / 2, 40, pdfWidth, pdfHeight);
    pdf.save(`Receipt_${receipt.receipt_id || receipt.id || receipt.fee_id}.pdf`);

    document.body.removeChild(container);
  }
};

export default Receipt;